(async () => {
  const root = document.getElementById('UrbanGifting');
  const dataNode = document.getElementById('UrbanGiftingCampaigns');
  if (!root || !dataNode) return;

  const searchParams = new URLSearchParams(window.location.search);
  const token = searchParams.get('gifting');
  const campaignSlug = searchParams.get('campaign');
  const pressMode = searchParams.get('gifting_press') === '1';
  const viewOnly = pressMode || searchParams.get('gifting_view') === '1';
  const draftPreview = searchParams.get('gifting_preview') === '1';
  const draftPreviewKey = searchParams.get('gifting_preview_key') || '';
  const catalogKey = searchParams.get('gifting_catalog_key') || '';
  if (!token) return;
  const digest = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(token));
  const tokenHash = [...new Uint8Array(digest)].map((byte) => byte.toString(16).padStart(2, '0')).join('');

  let campaigns = [];
  try {
    const catalogNode = document.getElementById('UrbanGiftingCatalog');
    const catalog = catalogNode ? JSON.parse(catalogNode.textContent || 'null') : null;
    if (catalog?.workspace) campaigns = window.UrbanGiftingStorage.decodeCatalog(catalog);
    else {
      const parsed = JSON.parse(dataNode.textContent || '[]');
      campaigns = Array.isArray(parsed) ? parsed : [];
    }
  } catch (_) {
    root.hidden = false;
    root.innerHTML = '<p role="alert">The gift catalog could not load. Please refresh this page. Your submitted requests have not been changed.</p>';
    document.body.classList.add('urban-gifting-active');
    return;
  }

  const handle = root.dataset.collectionHandle;
  const campaign = campaigns.find((item) => {
    const inviteTokenHashes = Array.isArray(item.inviteTokenHashes) ? item.inviteTokenHashes : [];
    const collectionHandles = Array.isArray(item.collectionHandles) ? item.collectionHandles : [item.collectionHandle];
    const validLandingHandles = [item.linkCollectionHandle, ...collectionHandles].filter(Boolean);
    const stableLandingMatch = handle === 'clothing' && campaignSlug && campaignSlug === item.slug;
    const validStatus = item.status === 'ACTIVE' || (draftPreview && item.status === 'DRAFT' && campaignSlug === item.slug);
    return validStatus && (validLandingHandles.includes(handle) || stableLandingMatch) && [item.publicTokenHash, ...inviteTokenHashes].includes(tokenHash);
  });
  if (!campaign) {
    if (campaigns.some(item=>item.slug===campaignSlug && item.recipientMode==='PRODUCT_ONLY')) {
      root.hidden=false;root.innerHTML='<p role="alert">This product gifting link is unavailable. Please ask our team for a new link.</p>';document.body.classList.add('urban-gifting-active');
    }
    return;
  }
  let productScope=null,assertProductGiftSelection=null;
  if (campaign.recipientMode==='PRODUCT_ONLY') {
    try {
      const policy=await import(root.dataset.productScopeUrl);
      productScope=policy.productGiftScope(campaign,tokenHash);
      assertProductGiftSelection=policy.assertProductGiftSelection;
    } catch (_) {
      root.hidden=false;root.innerHTML='<p role="alert">This product gifting link is unavailable. Please refresh or ask our team for a new link.</p>';document.body.classList.add('urban-gifting-active');return;
    }
  }
  const productOnly=Boolean(productScope);
  const isDraftPreview = draftPreview && campaign.status === 'DRAFT';
  const matchedInvite = (campaign.invites || []).find((invite) => invite.tokenHash === tokenHash);
  const isVIP = !productOnly && Boolean(matchedInvite?.vip);

  const productsNode = root.querySelector('.urban-gifting__products');
  const categoriesNode = root.querySelector('.urban-gifting__categories');
  const viewsNode = root.querySelector('.urban-gifting__views');
  const logoNode = root.querySelector('.urban-gifting__logo');
  const dialog = root.querySelector('.urban-gifting__dialog');
  const dialogContent = root.querySelector('.urban-gifting__dialog-content');
  let refreshProductTiming=null,shippingWatch=null;
  const counts = root.querySelectorAll('.urban-gifting__count');
  const stickySubmitButtons = root.querySelectorAll('.urban-gifting__sticky-submit');
  const collectionStickyButton = root.querySelector('.urban-gifting__sticky-submit--collection');
  const bagDialog = root.querySelector('.urban-gifting__bag-dialog');
  const bagItems = root.querySelector('.urban-gifting__bag-items');
  const requestDialog = root.querySelector('.urban-gifting__request-dialog');
  const requestForm = root.querySelector('.urban-gifting__request-form');
  const nativeFormSlot = root.querySelector('.urban-gifting__native-form-slot');
  root.dataset.nativeFormStatus = nativeFormSlot ? 'starting' : 'missing-slot';
  let nativeRequestForm = null;
  let nativeFormBound = false;
  let nativeSubmissionPending = false;
  let nativeSubmissionFailed = false;
  let nativeSubmissionAttempt = 0;
  const requestItems = root.querySelector('.urban-gifting__request-items');
  const requestError = root.querySelector('.urban-gifting__form-error');
  requestForm.addEventListener('submit', (event) => {
    // Always intercept the custom form, including before the native app loads.
    event.preventDefault();
    if (nativeFormBound) return;
    saveDeliveryDraft();
    requestError.textContent = 'The form is still loading. Please try again shortly.';
    requestError.hidden = false;
  });
  // A modal dialog occupies the browser's top layer. Shopify Forms appends
  // hCaptcha to body, where even its maximum z-index cannot cover that layer.
  // Temporarily make only the delivery dialog non-modal while a visible
  // challenge is present. The gifting screen stays open; hCaptcha controls
  // the verification, and modal focus handling returns when it closes.
  let requestYieldedToCaptcha = false;
  let captchaDisplayFrame = 0;
  function syncCaptchaDisplay() {
    captchaDisplayFrame = 0;
    // hCaptcha titles vary by version and locale. Its checkbox can also have
    // "challenge" in the title; only the full verification should release focus.
    const challengeVisible = [...document.querySelectorAll('iframe[title*="hcaptcha" i][title*="challenge" i]:not([src*="frame=checkbox"]), iframe[src*="hcaptcha.com"][src*="frame=challenge"]')].some((frame) => {
      const bounds = frame.getBoundingClientRect();
      if (!bounds.width || !bounds.height || bounds.bottom <= 0 || bounds.right <= 0 || bounds.top >= window.innerHeight || bounds.left >= window.innerWidth) return false;
      for (let parent = frame; parent && parent !== document.body; parent = parent.parentElement) {
        const style = getComputedStyle(parent);
        if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0') return false;
      }
      return true;
    });
    if (challengeVisible && requestDialog.open && requestDialog.matches(':modal')) {
      const scroll = requestDialog.scrollTop;
      requestDialog.close();
      requestDialog.show();
      requestDialog.scrollTop = scroll;
      requestYieldedToCaptcha = true;
    } else if (!challengeVisible && requestYieldedToCaptcha) {
      requestYieldedToCaptcha = false;
      if (requestDialog.open) {
        const scroll = requestDialog.scrollTop;
        requestDialog.close();
        requestDialog.showModal();
        requestDialog.scrollTop = scroll;
      }
      void settleVerification();
    }
  }
  function scheduleCaptchaDisplay() {
    if (!captchaDisplayFrame) captchaDisplayFrame = requestAnimationFrame(syncCaptchaDisplay);
  }
  new MutationObserver(scheduleCaptchaDisplay).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden', 'open', 'src', 'title']});
  // The first style mutation can still compute opacity 0 at the start of
  // hCaptcha's fade-in. CSS animation completion does not mutate the DOM.
  document.body.addEventListener('transitionend', scheduleCaptchaDisplay);
  document.body.addEventListener('transitioncancel', scheduleCaptchaDisplay);

  const maximum = productOnly ? 1 : isVIP ? Number.POSITIVE_INFINITY : Math.max(1, Number(campaign.maxItems || 1));
  const selected = new Map();
  const selectionStorageKey = `urban-gifting:gift-bag:${campaign.id}:${tokenHash}`;
  let deliveryDraft = null;
  try {
    deliveryDraft = window.UrbanGiftingDraft?.create(window.sessionStorage,`urban-gifting:delivery:${campaign.id}:${tokenHash}`);
  } catch (_) {}
  const restoredDelivery = viewOnly ? null : deliveryDraft?.read();
  let capture = null, activeCapture = null, captureRestoreError = '', capturePolling = null, captureComplete = false;
  try {
    capture = window.UrbanGiftingCapture.create({storage:window.sessionStorage,key:`urban-gifting:capture:${campaign.id}:${tokenHash}`,receiptUrl:`${window.Shopify.routes.root}search?view=gifting-receipt`});
    activeCapture = viewOnly ? null : capture.read();
  } catch (error) { captureRestoreError = error.message || 'Your previous submission could not be restored. Please check with our team.'; }
  if (restoredDelivery) {
    for (const [name,value] of Object.entries(restoredDelivery.fields)) {
      const input = requestForm.elements.namedItem(name);
      if (!input || (input.tagName === 'SELECT' && ![...input.options].some(option => option.value === value))) continue;
      input.value = value;
    }
    if (restoredDelivery.pending) {
      requestError.textContent = activeCapture ? '' : 'Please contact our team to check your previous request.';
      requestError.hidden = Boolean(activeCapture);
    }
  }
  let unconfirmedDelivery = restoredDelivery?.pending === true || Boolean(activeCapture);
  function deliveryFields() {
    return Object.fromEntries([...requestForm.elements].filter(element=>element.name).map(element=>[element.name,element.value]));
  }
  function lockDelivery(locked) {
    for (const element of requestForm.querySelectorAll('input,textarea,select')) {
      if (element.tagName === 'SELECT') element.disabled = locked;
      else element.readOnly = locked;
    }
    for (const button of requestDialog.querySelectorAll('.urban-gifting__request-close,[data-remove-selection]')) button.disabled = locked;
  }
  function showSubmissionSuccess() {
    if (captureComplete || !activeCapture || capture?.read()?.state !== 'CONFIRMED') return;
    captureComplete = true;
    nativeSubmissionPending = false;
    deliveryDraft?.clear();
    capture.clear();
    unconfirmedDelivery = false;
    selected.clear();
    try { window.localStorage.removeItem(selectionStorageKey); } catch (_) {}
    updateSelection();
    requestDialog.querySelector('.urban-gifting__request-page').innerHTML = '<section class="urban-gifting__success"><h2>Gift request received</h2><p>Thank you for your selection. Our team will review your request and delivery details. Shipping details will be available after approval.</p></section>';
    if (!requestDialog.open) requestDialog.showModal();
  }
  function confirmSavedCapture(wait = false) {
    if (captureComplete) return Promise.resolve(true);
    if (!activeCapture) return Promise.resolve(false);
    if (capturePolling) return capturePolling;
    const pending = (async () => {
      const deadline = Date.now() + 60000;
      for (let tries=0;tries<(wait ? 20 : 1) && (!tries || Date.now() < deadline);tries++) {
        try { if (await capture.check(activeCapture)) {showSubmissionSuccess();return true;} }
        catch (_) {}
        if (wait && tries<19 && Date.now() < deadline) await new Promise(resolve=>window.setTimeout(resolve,Math.min(3000,deadline-Date.now())));
      }
      if (captureComplete) return true;
      return false;
    })();
    capturePolling = pending;
    return pending.finally(() => {if (capturePolling === pending) capturePolling = null;});
  }
  async function settleVerification() {
    if (!nativeSubmissionPending || !activeCapture || captureComplete) return;
    const attempt = nativeSubmissionAttempt;
    if (await confirmSavedCapture(true)) return;
    if (captureComplete || attempt !== nativeSubmissionAttempt || requestYieldedToCaptcha) return;
    nativeSubmissionPending = false;
    nativeSubmissionFailed = true;
    requestError.textContent = 'Request not received yet. Please try again.';
    requestError.hidden = false;
    unconfirmedDelivery = true;
    saveDeliveryDraft();
    const submit = requestForm.querySelector('.urban-gifting__submit');
    submit.disabled = false;
    submit.textContent = 'SUBMIT GIFT REQUEST';
  }
  async function resumeNativeRetry() {
    if (!nativeFormBound || !selectionRestored || !activeCapture || captureComplete || !capture.takeRetry(activeCapture)) return;
    openRequest();
    if (await confirmSavedCapture()) return;
    requestForm.requestSubmit();
  }
  function saveDeliveryDraft() {
    if (!viewOnly && !captureComplete) deliveryDraft?.save(deliveryFields(),unconfirmedDelivery);
  }
  async function refreshNativeForm(retry = false) {
    if (!nativeSubmissionPending && !nativeSubmissionFailed && !unconfirmedDelivery) return;
    if (requestYieldedToCaptcha) return;
    if (activeCapture && await confirmSavedCapture()) return;
    if (capturePolling) return;
    saveDeliveryDraft();
    saveSelection();
    let restorable = false;
    try {
      restorable = window.UrbanGiftingDraft?.canRestore(deliveryDraft?.read(),deliveryFields(),[...selected.values()],window.localStorage.getItem(selectionStorageKey));
    } catch (_) {}
    if (!restorable) {
      requestError.textContent = 'Please keep this page open and contact our team.';
      requestError.hidden = false;
      return;
    }
    if (retry) capture.retryAfterReload(activeCapture);
    window.location.reload();
  }
  requestForm.addEventListener('input',saveDeliveryDraft);
  requestForm.addEventListener('change',saveDeliveryDraft);
  let selectionRestored = false;
  let products = [];
  let category = '';
  let selectedCaseDevice = '';
  let activeLook = null;

  function resetProductDialogScroll() {
    dialog.scrollTop = 0;
    dialogContent.scrollTop = 0;
    requestAnimationFrame(() => {
      dialog.scrollTop = 0;
      dialogContent.scrollTop = 0;
    });
  }

  root.classList.toggle('urban-gifting--product-only', productOnly);
  root.querySelector('.urban-gifting__close').hidden=productOnly;
  root.classList.toggle('urban-gifting--view-only', viewOnly);
  root.classList.toggle('urban-gifting--press', pressMode);
  root.querySelector('.urban-gifting__title').textContent = campaign.name || 'Gifting';
  const instructionsNode = root.querySelector('.urban-gifting__instructions');
  const removedPreviewDescription = 'Preview campaign for reviewing the private gifting storefront. Select up to one item; products and shipping are complimentary after approval.';
  const instructions = campaign.description === removedPreviewDescription ? '' : campaign.description;
  instructionsNode.textContent = instructions || '';
  instructionsNode.hidden = !instructions;
  root.querySelector('.urban-gifting__limit').textContent = isVIP ? 'VIP GIFTING · UNLIMITED SELECTIONS' : `SELECT UP TO ${maximum} ${maximum === 1 ? 'ITEM' : 'ITEMS'}`;
  root.hidden = false;
  document.body.classList.add('urban-gifting-active');

  function escapeHtml(value) {
    const node = document.createElement('div');
    node.textContent = String(value || '');
    return node.innerHTML;
  }

  function formatProductDescription(value) {
    const source = document.createElement('div');
    source.innerHTML = String(value || '');
    source.querySelectorAll('br').forEach((node) => node.replaceWith('\n'));
    source.querySelectorAll('p, div, li').forEach((node) => node.append('\n'));
    const text = String(source.textContent || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\r/g, '')
      .replace(/[ \t]+\n/g, '\n')
      .replace(/\n[ \t]+/g, '\n')
      .replace(/\n{2,}/g, '\n')
      .replace(/\s*-\s+(?=\S)/g, (match, offset) => `${offset ? '\n' : ''}- `)
      .replace(/([a-z0-9%)])-(?=[A-Z])/g, '$1\n- ')
      .replace(/(^|\n)\s*-\s*/g, '$1- ')
      .trim();
    return escapeHtml(text);
  }

  function pressCreditsMarkup(value) {
    const rows = String(value || '').split(/\r?\n/).map((line) => line.trim()).filter(Boolean).map((line) => {
      const parts = line.split(/\s+[—–-]\s+/);
      const role = parts.shift() || '';
      const name = parts.join(' — ');
      return `<div><dt>${escapeHtml(role)}</dt><dd>${escapeHtml(name)}</dd></div>`;
    });
    return rows.length ? `<dl>${rows.join('')}</dl>` : '';
  }

  function availableVariants(product) {
    if (isDraftPreview || campaign.inventoryMode === 'PRELAUNCH') return product.variants;
    // Ongoing gifting is fulfilled only from Boxzooka. This metafield is
    // synchronized from that warehouse, so inventory at other Shopify
    // locations must never make a variant eligible.
    return product.variants.filter((variant) => variant.usAvailable === true);
  }

  function decodeBase64(value) {
    const binary = atob(value);
    return Uint8Array.from(binary, (character) => character.charCodeAt(0));
  }

  async function privateCatalogProducts() {
    const publicLinkKey = tokenHash === campaign.publicTokenHash ? token : '';
    const encryptionKey = catalogKey || draftPreviewKey || publicLinkKey;
    if (!encryptionKey || !campaign.previewProductsEncrypted?.iv || !campaign.previewProductsEncrypted?.data) return [];
    try {
      const previewKeyHash = await crypto.subtle.digest('SHA-256', new TextEncoder().encode(encryptionKey));
      if ([...new Uint8Array(previewKeyHash)].map((byte) => byte.toString(16).padStart(2, '0')).join('') !== campaign.publicTokenHash) return [];
      const key = await crypto.subtle.importKey('raw', previewKeyHash, 'AES-GCM', false, ['decrypt']);
      const decrypted = await crypto.subtle.decrypt({name: 'AES-GCM', iv: decodeBase64(campaign.previewProductsEncrypted.iv)}, key, decodeBase64(campaign.previewProductsEncrypted.data));
      let decryptedBytes = new Uint8Array(decrypted);
      if (campaign.previewProductsEncrypted.compression === 'gzip') {
        if (typeof DecompressionStream !== 'function') return [];
        const decompressedStream = new Blob([decryptedBytes]).stream().pipeThrough(new DecompressionStream('gzip'));
        decryptedBytes = new Uint8Array(await new Response(decompressedStream).arrayBuffer());
      }
      const parsed = JSON.parse(new TextDecoder().decode(decryptedBytes));
      return Array.isArray(parsed) ? parsed : [];
    } catch (_) {
      return [];
    }
  }

  function assignedLookProducts() {
    const assigned = [...(campaign.lookbookProducts || []), ...(campaign.catalogProducts || []), ...(campaign.looks || []).flatMap((look) => look.products || [])];
    const unique = new Map();
    assigned.forEach((item) => {
      const key = numericId(item?.id) || item?.handle;
      if (!key) return;
      if (!unique.has(key)) unique.set(key, item);
    });
    return [...unique.values()];
  }

  function absoluteProductImage(url) {
    const value = String(url || '');
    return value.startsWith('//') ? `https:${value}` : value;
  }

  async function currentAssignedProduct(item) {
    if (!item?.handle) return null;
    try {
      const response = await fetch(`${window.Shopify.routes.root}products/${encodeURIComponent(item.handle)}?section_id=urban-gifting-data`, {headers: {Accept:'text/html'},cache:'no-store'});
      if (!response.ok) return null;
      const documentNode = new DOMParser().parseFromString(await response.text(),'text/html');
      const payload = JSON.parse(documentNode.querySelector('[data-urban-gifting-products]')?.textContent || 'null');
      return payload?.products?.find(product=>numericId(product.id)===numericId(item.id)) || null;
    } catch (_) { return null; }
  }

  async function refreshedAssignedProducts() {
    return (await Promise.all(assignedLookProducts().filter(item=>!productOnly || numericId(item.id)===productScope.productId).map(currentAssignedProduct))).filter(Boolean);
  }

  function productCategory(product) {
    const words = String(product.productType || '').toLowerCase();
    if (words.includes('case')) return 'CASE CLOSET';
    if (words.includes('bag') || words.includes('purse') || words.includes('tote')) return 'BAGS';
    return 'CLOTHING';
  }

  // Case selections are independent by phone model; other products retain one selection.
  function selectionKey(product, variant) {
    const device = !productOnly && productCategory(product) === 'CASE CLOSET' ? caseDeviceOption(product) : null;
    return device ? `${product.id}:phone:${variant[`option${device.position}`]}` : String(product.id);
  }

  function selectedForProduct(product) {
    if (!product) return undefined;
    return [...selected.values()].find((item) => String(item.productId) === String(product.id)
      && (productOnly || productCategory(product) !== 'CASE CLOSET' || variantMatchesCaseDevice(product, item)));
  }

  function saveSelection() {
    try {
      const items = [...selected.values()];
      if (items.length) window.localStorage.setItem(selectionStorageKey, JSON.stringify(items));
      else window.localStorage.removeItem(selectionStorageKey);
    } catch (_) {}
  }

  function restoreSelection() {
    if (viewOnly) return;
    try {
      const stored = JSON.parse(window.localStorage.getItem(selectionStorageKey) || '[]');
      if (activeCapture && !captureComplete) {
        for (const gift of JSON.parse(activeCapture.selectedJson)) {
          selected.set(`${gift.productId}:${gift.variantId}`, {id:gift.variantId,productId:gift.productId,productTitle:gift.productTitle,title:gift.variantTitle,image:gift.image || ''});
        }
        return;
      }
      if (!Array.isArray(stored)) return;
      stored.forEach((item) => {
        if (productOnly && selected.size) return;
        const product = products.find((candidate) => String(candidate.id) === String(item.productId));
        if (!product) return;
        const variant = availableVariants(product).find((candidate) => String(candidate.id) === String(item.id));
        if (!variant) return;
        selected.set(selectionKey(product, variant), {
          ...variant,
          productId: product.id,
          productTitle: product.title,
          image: collectionProductImage(product, variant),
        });
      });
    } catch (_) {
      try { window.localStorage.removeItem(selectionStorageKey); } catch (_) {}
    }
  }

  function updateSelection() {
    if (selectionRestored) saveSelection();
    const total = selected.size;
    const excess = isVIP ? 0 : Math.max(0, total - maximum);
    const waitingForCaseDevice = !productOnly && category === 'CASE CLOSET' && !selectedCaseDevice;
    const allowanceLabel = isVIP ? 'SELECT YOUR GIFTS' : `SELECT UP TO ${maximum} ${maximum === 1 ? 'ITEM' : 'ITEMS'}`;
    const actionLabel = total === 0
      ? allowanceLabel
      : excess
        ? `REMOVE ${excess} ${excess === 1 ? 'ITEM' : 'ITEMS'} TO CONTINUE`
        : 'CONTINUE TO SUBMIT GIFT REQUEST';
    counts.forEach((item) => { item.textContent = String(total); });
    stickySubmitButtons.forEach((button) => {
      button.hidden = viewOnly || (button === collectionStickyButton && (productOnly || waitingForCaseDevice));
      button.disabled = total === 0;
      button.textContent = actionLabel;
    });
    const finalSubmit = requestForm.querySelector('.urban-gifting__submit');
    if (finalSubmit) finalSubmit.disabled = nativeSubmissionPending || Boolean(captureRestoreError) || (unconfirmedDelivery && !activeCapture) || total === 0;
    productsNode.querySelectorAll('[data-product-id]').forEach((card) => card.classList.toggle('is-selected', Boolean(selectedForProduct(products.find((product) => String(product.id) === String(card.dataset.productId))))));
  }

  function productImage(product) {
    return product.image || product.images?.[0]?.src || '';
  }

  function numericId(value) {
    return String(value || '').split('/').pop();
  }

  function productForLookItem(item) {
    return products.find((product) => numericId(product.id) === numericId(item.id) || product.handle === item.handle);
  }

  function lookProductAvailability(item) {
    const globalProduct = (campaign.lookbookProducts || []).find((product) => numericId(product?.id) === numericId(item?.id) || (product?.handle && product.handle === item?.handle));
    return globalProduct?.availability || item?.availability || 'AVAILABLE_NOW';
  }

  function lookProductNote(item, product) {
    return lookProductAvailability(item) === 'NOT_AVAILABLE' ? 'NOT CURRENTLY AVAILABLE FOR GIFTING' : '';
  }

  function lookFitSizing(lookProducts, legacySizing = '') {
    const sizedProducts = lookProducts
      .map(({item, product}) => ({
        title: product?.title || item?.title || '',
        size: String(item?.modelSize || '').trim(),
      }))
      .filter(({title, size}) => title && size);
    if (!sizedProducts.length) return String(legacySizing || '').trim();
    const descriptions = sizedProducts.map(({title, size}) => `${title} in size ${size}`);
    if (descriptions.length === 1) return `Wearing ${descriptions[0]}`;
    return `Wearing ${descriptions.slice(0, -1).join(', ')} and ${descriptions.at(-1)}`;
  }

  function wholeInchHeight(value) {
    return String(value || '').replace(/(\d+)\.5(?=["”″])/g, '$1');
  }

  function lookImages(look) {
    const images = Array.isArray(look?.imageUrls) ? look.imageUrls.filter(Boolean) : [];
    if (images.length) return images;
    return look?.imageUrl ? [look.imageUrl] : [];
  }

  function campaignLooks() {
    if (productOnly || !campaign.looksEnabled || !Array.isArray(campaign.looks)) return [];
    return campaign.looks.filter((look) => lookImages(look).length && Array.isArray(look.products) && look.products.some((item) => productForLookItem(item) || item?.image || item?.title));
  }

  function campaignCatalogProducts() {
    if (campaign.productSelectionMode !== 'EXPLICIT') return products;
    const selectedKeys = new Set((campaign.catalogProducts || []).map((item) => numericId(item?.id) || String(item?.handle || '')).filter(Boolean));
    return products.filter((product) => selectedKeys.has(numericId(product?.id) || String(product?.handle || '')));
  }

  function looksFeaturingProduct(product) {
    const productId = numericId(product?.id);
    const handle = String(product?.handle || '');
    return campaignLooks().filter((look) => (look.products || []).some((item) => {
      return (productId && numericId(item?.id) === productId) || (handle && String(item?.handle || '') === handle);
    }));
  }

  function phoneSizeTag(value) {
    return `phone-size_${String(value || '').toLowerCase().trim().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '')}|`;
  }

  function isStudioFlat(media) {
    return String(media?.alt || '').toLowerCase().includes('studio-flat');
  }

  function studioFlatRank(media) {
    const tags = [...String(media?.alt || '').toLowerCase().matchAll(/phone-size_iphone-(\d+)(?:-([a-z0-9/-]+))?\|/g)];
    if (!tags.length) return -1;
    return Math.max(...tags.map(([, generation, model = '']) => {
      let modelRank = 10;
      if (model.includes('pro-max')) modelRank = 50;
      else if (model.includes('pro')) modelRank = 40;
      else if (model.includes('plus')) modelRank = 30;
      else if (model.includes('air')) modelRank = 20;
      return Number(generation) * 100 + modelRank;
    }));
  }

  function preferredStudioFlat(product) {
    const studioFlats = Array.isArray(product.media) ? product.media.filter((media) => media?.src && isStudioFlat(media)) : [];
    if (!studioFlats.length) return null;
    if (selectedCaseDevice) {
      const selectedTag = phoneSizeTag(selectedCaseDevice);
      const exactMatches = studioFlats.filter((media) => String(media.alt || '').toLowerCase().includes(selectedTag));
      if (exactMatches.length) return exactMatches.at(-1);
    }
    return studioFlats.reduce((preferred, media) => studioFlatRank(media) >= studioFlatRank(preferred) ? media : preferred);
  }

  function collectionProductImage(product, variant = null) {
    if (productCategory(product) !== 'CASE CLOSET') return productImage(product);
    const option = caseDeviceOption(product);
    const device = variant && option ? variant[`option${option.position}`] : selectedCaseDevice;
    if (!device) return preferredStudioFlat(product)?.src || productImage(product);
    const media = Array.isArray(product.media) ? product.media : [];
    const exactStudio = media.filter((item) => item?.src && isStudioFlat(item) && String(item.alt || '').toLowerCase().includes(phoneSizeTag(device))).at(-1);
    if (exactStudio) return exactStudio.src;
    const matchingVariant = variant || availableVariants(product).find((item) => option && item[`option${option.position}`] === device);
    return media.find((item) => item?.src && matchingVariant?.featuredMediaId && String(item.id) === String(matchingVariant.featuredMediaId))?.src || '';
  }

  // Modern case galleries share the storefront's SKU-marker boundaries.
  // Exact back/studio tags must not suppress the assigned ordinary-image group.
  function assignedCaseGalleryImages(product, variant) {
    const featuredIndex = product.media.findIndex((media) => String(media.id || '') === String(variant.featuredMediaId || ''));
    if (featuredIndex < 0) return null;
    const featured = product.media[featuredIndex];
    const sourceVariant = product.variants.find((item) => String(item.id) === String(variant.galleryGroupVariantId || ''));
    const sourceIndex = sourceVariant ? product.media.findIndex((media) => String(media.id) === String(sourceVariant.featuredMediaId || '')) : -1;
    const sourceMedia = sourceIndex >= 0 ? product.media[sourceIndex] : null;
    const groupIndex = isStudioFlat(featured) && sourceMedia && !isStudioFlat(sourceMedia) && !String(sourceMedia.alt || '').toLowerCase().includes('back|') ? sourceIndex : featuredIndex;
    const markers = new Set(product.variants.map((item) => String(item.featuredMediaId || '')).filter(Boolean));
    const regular = [];
    let previousWasStudio = false;
    for (let index = groupIndex; index < product.media.length; index += 1) {
      const media = product.media[index];
      const studio = isStudioFlat(media);
      if (index > groupIndex && markers.has(String(media.id || '')) && !(previousWasStudio && studio)) break;
      previousWasStudio = studio;
      if (!studio && !String(media.alt || '').toLowerCase().includes('back|') && media.src) regular.push(media);
    }
    const selectedTag = phoneSizeTag(selectedCaseDevice);
    const back = product.media.find((media) => media.src && String(media.alt || '').toLowerCase().includes('back|') && String(media.alt || '').toLowerCase().includes(selectedTag));
    const studio = isStudioFlat(featured) ? featured : preferredStudioFlat(product);
    const ordered = isStudioFlat(featured) ? [featured, ...regular, back] : [...regular, back, studio];
    return [...new Set(ordered.filter((media) => media?.src).map((media) => media.src))];
  }

  function productGalleryImages(product, variant) {
    const fallback = (Array.isArray(product.images) && product.images.length ? product.images : [productImage(product)]).filter(Boolean);
    if (productCategory(product) !== 'CASE CLOSET' || !selectedCaseDevice || !Array.isArray(product.media) || !product.media.length) return fallback;
    if (/^iPhone (17|18)(?:\s|$)/i.test(selectedCaseDevice) && variant) {
      const assignedImages = assignedCaseGalleryImages(product, variant);
      if (assignedImages) return assignedImages;
    }
    const selectedTag = phoneSizeTag(selectedCaseDevice);
    const featuredIndex = product.media.findIndex((media) => String(media.id || '') === String(variant?.featuredMediaId || ''));
    const featured = featuredIndex >= 0 ? product.media[featuredIndex] : null;
    const studioFlat = preferredStudioFlat(product);
    let matching = product.media.filter((media) => String(media.alt || '').toLowerCase().includes(selectedTag));

    if (!matching.length && featured) {
      const featuredTags = String(featured.alt || '').toLowerCase().match(/phone-size_[a-z0-9-]+\|/g) || [];
      if (featuredTags.length) {
        matching = product.media.filter((media) => featuredTags.some((tag) => String(media.alt || '').toLowerCase().includes(tag)));
      } else {
        matching = [featured];
        for (let index = featuredIndex + 1; index < product.media.length; index += 1) {
          const media = product.media[index];
          const alt = String(media.alt || '').toLowerCase();
          const startsAnotherVariant = product.variants.some((item) => String(item.featuredMediaId || '') === String(media.id || ''));
          if (alt.includes('phone-size_') || startsAnotherVariant) break;
          matching.push(media);
        }
      }
    }

    matching = matching.filter((media) => media?.src);
    const featuredMatch = matching.find((media) => String(media.id || '') === String(featured?.id || ''));
    const preferredFeaturedMatch = featuredMatch && (!isStudioFlat(featuredMatch) || featuredMatch === studioFlat) ? featuredMatch : null;
    const lead = preferredFeaturedMatch || (studioFlat === featured ? studioFlat : null) || matching.find((media) => !isStudioFlat(media));
    const regular = matching.filter((media) => media !== lead && !isStudioFlat(media) && !String(media.alt || '').toLowerCase().includes('back|'));
    const back = matching.find((media) => String(media.alt || '').toLowerCase().includes('back|'));
    const ordered = [lead, ...regular, back, studioFlat === lead ? null : studioFlat].filter(Boolean).map((media) => media.src);
    const caseFallback = featured?.src || productImage(product) || fallback[0];
    return [...new Set(ordered.length ? ordered : [caseFallback].filter(Boolean))];
  }

  function caseDeviceOption(product) {
    const options = product.options || [];
    const namedOption = options.find((option) => /phone|device|model/i.test(option.name));
    if (namedOption || productCategory(product) !== 'CASE CLOSET') return namedOption;
    return options.find((option) => {
      if (!/^size$/i.test(String(option.name || '').trim())) return false;
      const values = (product.variants || []).map((variant) => variant[`option${option.position}`]);
      return values.length > 0 && values.every((value) => /^iphone(?:\s|$)/i.test(String(value || '').trim()));
    });
  }

  function variantMatchesCaseDevice(product, variant) {
    const option = caseDeviceOption(product);
    return !selectedCaseDevice || !option || variant[`option${option.position}`] === selectedCaseDevice;
  }

  function caseDeviceValues() {
    const values = new Set();
    campaignCatalogProducts().filter((product) => productCategory(product) === 'CASE CLOSET').forEach((product) => {
      const option = caseDeviceOption(product);
      if (!option) return;
      availableVariants(product).forEach((variant) => {
        const value = variant[`option${option.position}`];
        if (value) values.add(value);
      });
    });
    const modelNumber = (value) => Number(String(value).match(/iphone\s*(\d+)/i)?.[1] || 0);
    const familyOrder = (value) => /iphone\s*duo/i.test(String(value)) ? 17.5 : modelNumber(value);
    const modelRank = (value) => {
      if (/pro max/i.test(value)) return 0;
      if (/\bpro\b/i.test(value)) return 1;
      if (/\bplus\b/i.test(value)) return 2;
      return 3;
    };
    return [...values]
      .filter((value) => {
        const number = modelNumber(value);
        return /iphone\s*duo/i.test(String(value)) || (number >= 16 && number <= 18);
      })
      .sort((a, b) => familyOrder(b) - familyOrder(a) || modelRank(a) - modelRank(b) || a.localeCompare(b, undefined, {numeric: true}));
  }

  function renderCaseDeviceGate() {
    const values = caseDeviceValues();
    collectionStickyButton.hidden = true;
    productsNode.innerHTML = `<section class="urban-gifting__device-gate">
      <p>CASE CLOSET</p>
      <h2>SELECT YOUR PHONE MODEL</h2>
      ${values.length ? `<div class="urban-gifting__device-values">${values.map((value) => `<button type="button" data-device="${escapeHtml(value)}">${escapeHtml(value)}</button>`).join('')}</div>` : '<p>NO PHONE MODELS ARE AVAILABLE.</p>'}
    </section>`;
    productsNode.querySelectorAll('[data-device]').forEach((button) => button.addEventListener('click', () => {
      selectedCaseDevice = button.dataset.device;
      renderProducts();
    }));
  }

  function renderProducts() {
    if (productOnly) {productsNode.innerHTML='';collectionStickyButton.hidden=true;gridButton.hidden=true;return;}
    collectionStickyButton.hidden = viewOnly;
    setGridSize();
    if (category === 'LOOKS') {
      const looks = campaignLooks();
      const lookbookText = String(campaign.lookbookText || '').trim();
      const pressCredits = String(campaign.pressCredits || '').trim();
      const introduction = lookbookText ? `<section class="urban-gifting__lookbook-intro"><p>${escapeHtml(lookbookText)}</p></section>` : '';
      const credits = pressMode && pressCredits ? `<section class="urban-gifting__press-credits"><h2>CREDITS</h2>${pressCreditsMarkup(pressCredits)}</section>` : '';
      const lookMarkup = looks.length ? looks.map((look) => `<article class="urban-gifting__look" data-look-id="${escapeHtml(look.id)}">
        <button class="urban-gifting__look-button" type="button">
          <div class="urban-gifting__look-image-wrap"><img class="urban-gifting__look-image" src="${escapeHtml(lookImages(look)[0])}" alt="${escapeHtml(look.title || 'Look')}" loading="lazy"></div>
          <p class="urban-gifting__name">${escapeHtml(look.title || 'LOOK')}</p>
        </button>
      </article>`).join('') : '<p class="urban-gifting__empty">NO LOOKBOOK ENTRIES AVAILABLE.</p>';
      productsNode.innerHTML = pressMode ? introduction + lookMarkup + credits : lookMarkup + introduction;
      productsNode.querySelectorAll('.urban-gifting__look-button').forEach((button) => button.addEventListener('click', () => openLook(looks.find((look) => String(look.id) === button.closest('[data-look-id]').dataset.lookId))));
      return;
    }
    if (category === 'SHOP_LOOKS') {
      const looks = campaignLooks();
      productsNode.innerHTML = `<section class="urban-gifting__shop-look-feed">
        ${looks.map((look, lookIndex) => {
          const lookProducts = (look.products || []).map((item) => ({item, product: productForLookItem(item)}))
            .filter(({item, product}) => product || item?.image || item?.title);
          return `<article class="urban-gifting__shop-look" data-shop-look-id="${escapeHtml(look.id)}">
            <button class="urban-gifting__shop-look-cover" type="button" aria-label="Open ${escapeHtml(look.title || `Look ${lookIndex + 1}`)}">
              <img src="${escapeHtml(lookImages(look)[0])}" alt="${escapeHtml(look.title || `Look ${lookIndex + 1}`)}" loading="lazy">
              <span>${escapeHtml(look.title || `LOOK ${String(lookIndex + 1).padStart(2, '0')}`)}</span>
            </button>
            <div class="urban-gifting__shop-look-products">
              ${lookProducts.map(({item, product}) => {
                const image = productImage(product || item) || item.image || '';
                const title = product?.title || item.title || 'Product';
                const unavailable = lookProductAvailability(item) === 'NOT_AVAILABLE' || !product;
                return `<button class="urban-gifting__shop-look-product" type="button"${unavailable ? ' disabled aria-disabled="true"' : ` data-shop-product="${escapeHtml(product.id)}"`}>
                  <span class="urban-gifting__shop-look-product-image">${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(title)}" loading="lazy">` : '<span>IMAGE UNAVAILABLE</span>'}</span>
                  <span class="urban-gifting__shop-look-product-title">${escapeHtml(title)}</span>
                  ${unavailable ? '<small>NOT CURRENTLY AVAILABLE FOR GIFTING</small>' : ''}
                </button>`;
              }).join('')}
            </div>
          </article>`;
        }).join('')}
      </section>`;
      productsNode.querySelectorAll('.urban-gifting__shop-look-cover').forEach((button) => button.addEventListener('click', () => {
        const lookId = button.closest('[data-shop-look-id]').dataset.shopLookId;
        openLook(looks.find((look) => String(look.id) === lookId));
      }));
      productsNode.querySelectorAll('[data-shop-product]').forEach((button) => button.addEventListener('click', () => {
        openProduct(products.find((product) => String(product.id) === String(button.dataset.shopProduct)));
      }));
      return;
    }
    if (category === 'CASE CLOSET' && !selectedCaseDevice) {
      renderCaseDeviceGate();
      return;
    }
    const visible = campaignCatalogProducts().filter((product) => productCategory(product) === category)
      .filter((product) => category !== 'CASE CLOSET' || !selectedCaseDevice || (product.variants || []).some((variant) => variantMatchesCaseDevice(product, variant)));
    if (!visible.length) {
      productsNode.innerHTML = '<p class="urban-gifting__empty">NO GIFTS AVAILABLE IN THIS CATEGORY.</p>';
      return;
    }
    const deviceControl = category === 'CASE CLOSET' ? `<div class="urban-gifting__device-current"><span>${escapeHtml(selectedCaseDevice)}</span><button type="button" data-change-device>CHANGE PHONE MODEL</button></div>` : '';
    productsNode.innerHTML = deviceControl + visible.map((product) => {
      const chosen = selectedForProduct(product);
      const status = chosen ? chosen.title : '';
      const cardImage = collectionProductImage(product);
      return `<article class="urban-gifting__product${chosen ? ' is-selected' : ''}" data-product-id="${product.id}">
        <button class="urban-gifting__product-button" type="button">
          <div class="urban-gifting__image-wrap">${cardImage ? `<img class="urban-gifting__image" src="${escapeHtml(cardImage)}" alt="${escapeHtml(product.title)}" loading="lazy">` : '<span>IMAGE UNAVAILABLE FOR THIS SIZE</span>'}</div>
          <p class="urban-gifting__name">${escapeHtml(product.title)}</p>
          ${window.UrbanGiftingShipping?.summary(product,availableVariants(product)) ? `<p class="urban-gifting__shipping-note">${escapeHtml(window.UrbanGiftingShipping.summary(product,availableVariants(product)))}</p>` : ''}
          ${status ? `<p class="urban-gifting__status">${escapeHtml(status)}</p>` : ''}
        </button>
      </article>`;
    }).join('');
    productsNode.querySelector('[data-change-device]')?.addEventListener('click', () => {
      selectedCaseDevice = '';
      renderCaseDeviceGate();
    });
    productsNode.querySelectorAll('.urban-gifting__product-button').forEach((button) => button.addEventListener('click', () => openProduct(products.find((item) => String(item.id) === button.closest('[data-product-id]').dataset.productId))));
  }

  function renderCategories() {
    if (productOnly) {categoriesNode.hidden=true;viewsNode.hidden=true;return;}
    const catalogProducts = campaignCatalogProducts();
    const categories = ['CLOTHING', 'CASE CLOSET', 'BAGS'].filter((item) => catalogProducts.some((product) => productCategory(product) === item));
    categoriesNode.hidden = pressMode || campaignLooks().length > 0 || category === 'LOOKS' || categories.length < 2;
    categoriesNode.innerHTML = categories.map((item) => `<button class="urban-gifting__category" type="button" data-category="${escapeHtml(item)}" aria-current="${item === category || (item === 'CLOTHING' && category === 'LOOKS')}">${escapeHtml(item)}</button>`).join('');
    categoriesNode.querySelectorAll('button').forEach((button) => button.addEventListener('click', () => {
      category = button.dataset.category;
      renderCategories();
      renderProducts();
    }));
    renderViewTabs();
  }

  function renderViewTabs() {
    const visible = !pressMode && campaignLooks().length > 0 && (category === 'SHOP_LOOKS' || category === 'LOOKS');
    viewsNode.hidden = !visible;
    if (!visible) {
      viewsNode.innerHTML = '';
      return;
    }
    viewsNode.innerHTML = `<button type="button" data-view="LOOKS" aria-current="${category === 'LOOKS'}">LOOKBOOK</button>
      <button type="button" data-view="PRODUCTS" aria-current="${category === 'SHOP_LOOKS'}">PRODUCTS</button>`;
    viewsNode.querySelectorAll('[data-view]').forEach((button) => button.addEventListener('click', () => {
      category = button.dataset.view === 'LOOKS' ? 'LOOKS' : 'SHOP_LOOKS';
      renderCategories();
      renderProducts();
    }));
  }

  function openLook(look) {
    if (!look) return;
    activeLook = look;
    const looks = campaignLooks();
    const lookIndex = looks.findIndex((item) => String(item.id) === String(look.id));
    const previousLook = lookIndex > 0 ? looks[lookIndex - 1] : null;
    const nextLook = lookIndex >= 0 && lookIndex < looks.length - 1 ? looks[lookIndex + 1] : null;
    const images = lookImages(look);
    const lookProducts = look.products.map((item) => ({item, product: productForLookItem(item)})).filter(({item, product}) => product || item?.image || item?.title);
    const fitModel = wholeInchHeight(look.fitDetails?.model).trim();
    const fitSizing = lookFitSizing(lookProducts, look.fitDetails?.sizing);
    dialogContent.innerHTML = `<div class="urban-gifting__look-page">
      <div class="urban-gifting__look-gallery-shell">
        <section class="urban-gifting__look-gallery" tabindex="0" aria-label="${escapeHtml(look.title || 'Look')} images">
          ${images.map((imageUrl, imageIndex) => `<div class="urban-gifting__look-gallery-item">
            <img src="${escapeHtml(imageUrl)}" alt="${escapeHtml(look.title || 'Look')} image ${imageIndex + 1} of ${images.length}"${imageIndex ? ' loading="lazy"' : ''}>
          </div>`).join('')}
        </section>
        ${images.length > 1 ? `<nav class="urban-gifting__look-gallery-nav" aria-label="Image navigation">
          <button class="urban-gifting__look-gallery-step" type="button" data-previous-look-image aria-label="Previous image">PREVIOUS</button>
          <span class="urban-gifting__look-gallery-count" data-look-image-count aria-live="polite">1 / ${images.length}</span>
          <button class="urban-gifting__look-gallery-step" type="button" data-next-look-image aria-label="Next image">NEXT</button>
          <div class="urban-gifting__look-gallery-pages">
            ${images.map((imageUrl, imageIndex) => `<button type="button" data-look-image-page="${imageIndex}" aria-label="Go to image ${imageIndex + 1}" aria-current="${imageIndex === 0}"><img src="${escapeHtml(imageUrl)}" alt="" loading="lazy"></button>`).join('')}
          </div>
        </nav>` : ''}
      </div>
      <section class="urban-gifting__look-details">
        <nav class="urban-gifting__look-heading" aria-label="Lookbook navigation">
          ${previousLook ? '<button type="button" data-previous-look>PREVIOUS LOOK</button>' : '<span aria-hidden="true"></span>'}
          <h2>${escapeHtml(look.title || 'LOOK')}</h2>
          ${nextLook ? '<button type="button" data-next-look>NEXT LOOK</button>' : '<span aria-hidden="true"></span>'}
        </nav>
        <p>SELECT FROM THIS LOOK</p>
        <div class="urban-gifting__look-products">
          ${lookProducts.map(({item, product}) => {
            const availability = lookProductAvailability(item);
            const selectable = Boolean(product) && availability !== 'NOT_AVAILABLE';
            const image = productImage(product || item) || item.image || '';
            const title = product?.title || item.title || 'Product';
            const note = lookProductNote(item, product);
            return `<button type="button"${selectable ? ` data-look-product="${escapeHtml(product.id)}"` : ' disabled aria-disabled="true"'}>
              ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(title)}">` : ''}
              <span class="urban-gifting__look-product-title">${escapeHtml(title)}</span>
              ${note ? `<small class="urban-gifting__look-product-note">${escapeHtml(note)}</small>` : ''}
            </button>`;
          }).join('')}
        </div>
        ${fitModel || fitSizing ? `<div class="urban-gifting__look-fit-details">
          ${fitModel ? `<p>${escapeHtml(fitModel)}</p>` : ''}
          ${fitSizing ? `<p>${escapeHtml(fitSizing)}</p>` : ''}
        </div>` : ''}
      </section>
    </div>`;
    dialogContent.querySelectorAll('[data-look-product]').forEach((button) => button.addEventListener('click', () => {
      const product = products.find((item) => String(item.id) === button.dataset.lookProduct);
      if (product) openProduct(product);
    }));
    dialogContent.querySelector('[data-previous-look]')?.addEventListener('click', () => openLook(previousLook));
    dialogContent.querySelector('[data-next-look]')?.addEventListener('click', () => openLook(nextLook));
    const lookGallery = dialogContent.querySelector('.urban-gifting__look-gallery');
    const lookGalleryItems = [...dialogContent.querySelectorAll('.urban-gifting__look-gallery-item')];
    const previousImageButton = dialogContent.querySelector('[data-previous-look-image]');
    const nextImageButton = dialogContent.querySelector('[data-next-look-image]');
    const imagePageButtons = [...dialogContent.querySelectorAll('[data-look-image-page]')];
    const imagePageStrip = dialogContent.querySelector('.urban-gifting__look-gallery-pages');
    const imageCount = dialogContent.querySelector('[data-look-image-count]');
    let activeImageIndex = 0;
    const isDesktopGallery = () => window.matchMedia('(min-width: 900px) and (hover: hover) and (pointer: fine)').matches;
    const updateImageNavigation = (index) => {
      activeImageIndex = Math.max(0, Math.min(index, lookGalleryItems.length - 1));
      if (imageCount) imageCount.textContent = `${activeImageIndex + 1} / ${lookGalleryItems.length}`;
      if (previousImageButton) previousImageButton.disabled = activeImageIndex === 0;
      if (nextImageButton) nextImageButton.disabled = activeImageIndex === lookGalleryItems.length - 1;
      imagePageButtons.forEach((button, buttonIndex) => button.setAttribute('aria-current', String(buttonIndex === activeImageIndex)));
      const activePageButton = imagePageButtons[activeImageIndex];
      if (!isDesktopGallery() && imagePageStrip && activePageButton) {
        imagePageStrip.scrollTo({left: activePageButton.offsetLeft - ((imagePageStrip.clientWidth - activePageButton.offsetWidth) / 2), behavior: 'smooth'});
      }
    };
    const goToLookImage = (index) => {
      const target = lookGalleryItems[Math.max(0, Math.min(index, lookGalleryItems.length - 1))];
      if (!lookGallery || !target) return;
      lookGallery.scrollTo({
        left: isDesktopGallery() ? 0 : target.offsetLeft,
        top: isDesktopGallery() ? target.offsetTop : 0,
        behavior: 'smooth',
      });
      updateImageNavigation(lookGalleryItems.indexOf(target));
    };
    previousImageButton?.addEventListener('click', () => goToLookImage(activeImageIndex - 1));
    nextImageButton?.addEventListener('click', () => goToLookImage(activeImageIndex + 1));
    imagePageButtons.forEach((button) => button.addEventListener('click', () => goToLookImage(Number(button.dataset.lookImagePage))));
    if (lookGalleryItems.length > 1 && lookGallery) {
      let scrollFrame = 0;
      lookGallery.addEventListener('scroll', () => {
        cancelAnimationFrame(scrollFrame);
        scrollFrame = requestAnimationFrame(() => {
          const galleryPosition = isDesktopGallery() ? lookGallery.scrollTop : lookGallery.scrollLeft;
          const closestIndex = lookGalleryItems.reduce((closest, item, index) => {
            const itemPosition = isDesktopGallery() ? item.offsetTop : item.offsetLeft;
            const closestPosition = isDesktopGallery() ? lookGalleryItems[closest].offsetTop : lookGalleryItems[closest].offsetLeft;
            return Math.abs(itemPosition - galleryPosition) < Math.abs(closestPosition - galleryPosition) ? index : closest;
          }, 0);
          updateImageNavigation(closestIndex);
        });
      }, {passive: true});
      lookGallery.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          event.preventDefault();
          goToLookImage(activeImageIndex - 1);
        }
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          event.preventDefault();
          goToLookImage(activeImageIndex + 1);
        }
      });
      updateImageNavigation(0);
    }
    if (!dialog.open) dialog.showModal();
    resetProductDialogScroll();
  }

  function orderedOptions(product) {
    const priority = /phone|device|model|size/i;
    return [...(product.options || [])].sort((a, b) => Number(priority.test(b.name)) - Number(priority.test(a.name)));
  }

  function setupSizeGuide(panel, sizeGuide) {
    const source = document.createElement('div');
    source.innerHTML = sizeGuide.html || '';
    const image = source.querySelector('img');
    if (image) panel.querySelector('[data-size-guide-image]').appendChild(image);
    const sourceTable = source.querySelector('table');
    const tableMount = panel.querySelector('[data-size-guide-table]');
    if (sourceTable) {
      const rows = [...sourceTable.querySelectorAll('tr')].map((row) => [...row.querySelectorAll('th, td')].map((cell) => cell.textContent.trim())).filter((row) => row.length);
      if (rows.length) {
        const grid = document.createElement('div');
        grid.className = 'urban-gifting__size-grid';
        grid.style.setProperty('--size-columns', String(Math.max(1, rows[0].length - 1)));
        rows.forEach((row, rowIndex) => row.forEach((value, columnIndex) => {
          const cell = document.createElement('div');
          cell.className = `urban-gifting__size-cell${rowIndex === 0 ? ' is-heading' : ''}${columnIndex === 0 ? ' is-label' : ''}`;
          cell.textContent = value;
          if (rowIndex > 0 && columnIndex > 0) {
            const centimeters = Number.parseFloat(value.replace(',', '.'));
            if (Number.isFinite(centimeters)) cell.dataset.centimeters = String(centimeters);
          }
          grid.appendChild(cell);
        }));
        tableMount.appendChild(grid);
      }
      sourceTable.remove();
    }
    source.querySelectorAll('img').forEach((item) => item.remove());
    const notes = panel.querySelector('[data-size-guide-notes]');
    if (source.textContent.trim()) notes.innerHTML = source.innerHTML;
    const unitButtons = [...panel.querySelectorAll('[data-size-unit]')];
    unitButtons.forEach((button) => button.addEventListener('click', () => {
      const unit = button.dataset.sizeUnit;
      unitButtons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      panel.querySelectorAll('[data-centimeters]').forEach((cell) => {
        const centimeters = Number(cell.dataset.centimeters);
        cell.textContent = unit === 'in' ? (centimeters / 2.54).toFixed(1) : String(centimeters);
      });
    }));
  }

  function openProduct(product) {
    if (!product || (productOnly && numericId(product.id)!==productScope.productId)) return;
    const options = orderedOptions(product);
    const usable = availableVariants(product).filter((variant) => productOnly || productCategory(product) !== 'CASE CLOSET' || variantMatchesCaseDevice(product, variant));
    const availableOptionValues = (option) => [...new Set(usable.map((variant) => variant[`option${option.position}`]).filter(Boolean))];
    const existing = selectedForProduct(product);
    const optionState = {};
    options.forEach((option) => {
      if (existing?.[`option${option.position}`]) optionState[option.position] = existing[`option${option.position}`];
      else if (productCategory(product) === 'CASE CLOSET' && selectedCaseDevice && caseDeviceOption(product)?.position === option.position) optionState[option.position] = selectedCaseDevice;
      else if (availableOptionValues(option).length === 1) optionState[option.position] = availableOptionValues(option)[0];
    });
    const visibleOptions = options.filter((option) => {
      if (!productOnly && productCategory(product) === 'CASE CLOSET' && caseDeviceOption(product)?.position === option.position) return false;
      const values = viewOnly ? availableOptionValues(option) : (option.values || []);
      return values.length > 1;
    });
    const primaryOption = visibleOptions.find((option) => !optionState[option.position]) || visibleOptions[0] || options[0];
    const choiceLabel = primaryOption?.name?.toLowerCase() || 'gift';
    const galleryImages = productGalleryImages(product, usable[0]);
    const featuredLooks = looksFeaturingProduct(product);
    dialogContent.innerHTML = `<div class="urban-gifting__dialog-page">
      <section class="urban-gifting__gallery" aria-label="${escapeHtml(product.title)} images">
        <div class="urban-gifting__gallery-track">
          ${galleryImages.map((image, index) => `<img class="urban-gifting__dialog-image" src="${escapeHtml(image)}" alt="${escapeHtml(product.title)}${index ? ` image ${index + 1}` : ''}">`).join('')}
        </div>
        ${galleryImages.length > 1 ? `<div class="urban-gifting__gallery-dots">${galleryImages.map((_, index) => `<button type="button" aria-label="Go to image ${index + 1}" aria-current="${index === 0}"></button>`).join('')}</div>` : ''}
      </section>
      <div class="urban-gifting__dialog-details">
        <h2 class="urban-gifting__dialog-title">${escapeHtml(product.title)}</h2>
        <button class="urban-gifting__selector-toggle" type="button" aria-expanded="false"${viewOnly ? ' hidden' : ''}>Select a ${escapeHtml(choiceLabel)}</button>
        <div class="urban-gifting__selectors"${viewOnly ? '' : ' hidden'}></div>
        <p class="urban-gifting__shipping-note" data-product-shipping role="status" aria-live="polite" hidden></p>
        <div class="urban-gifting__selection-action">
          <button class="urban-gifting__select" type="button">${existing ? 'UPDATE SELECTION' : 'ADD TO GIFT BAG'}</button>
          <p class="urban-gifting__selection-feedback" role="status" aria-live="polite" hidden></p>
        </div>
        ${existing ? '<button class="urban-gifting__remove" type="button">REMOVE GIFT</button>' : ''}
        ${featuredLooks.length ? `<section class="urban-gifting__featured-looks">
          <h3>FEATURED IN THE LOOKBOOK</h3>
          <div>${featuredLooks.map((look) => `<button type="button" data-featured-look="${escapeHtml(look.id)}">
            <img src="${escapeHtml(lookImages(look)[0])}" alt="${escapeHtml(look.title || 'Look')}">
            <span>${escapeHtml(look.title || 'LOOK')}</span>
          </button>`).join('')}</div>
        </section>` : ''}
        ${product.description ? `<section class="urban-gifting__product-information"><h3>PRODUCT INFORMATION</h3><p>${formatProductDescription(product.description)}</p></section>` : ''}
        ${productCategory(product) === 'CLOTHING' && product.sizeGuide?.html ? '<section class="urban-gifting__size-guide"><h3>SIZE GUIDE</h3><div data-size-guide-image></div><div class="urban-gifting__size-units"><span>MEASUREMENTS IN</span><button type="button" data-size-unit="cm" aria-pressed="true">CM</button><span>/</span><button type="button" data-size-unit="in" aria-pressed="false">INCHES</button></div><div data-size-guide-table></div><div data-size-guide-notes></div></section>' : ''}
      </div>
    </div>`;
    const galleryTrack = dialogContent.querySelector('.urban-gifting__gallery-track');
    const galleryDots = [...dialogContent.querySelectorAll('.urban-gifting__gallery-dots button')];
    galleryDots.forEach((dot, index) => dot.addEventListener('click', () => galleryTrack.scrollTo({left: galleryTrack.clientWidth * index, behavior: 'smooth'})));
    if (galleryDots.length) galleryTrack.addEventListener('scroll', () => {
      const active = Math.round(galleryTrack.scrollLeft / Math.max(1, galleryTrack.clientWidth));
      galleryDots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
    }, {passive: true});
    const selectors = dialogContent.querySelector('.urban-gifting__selectors');
    const selectorToggle = dialogContent.querySelector('.urban-gifting__selector-toggle');
    const selectButton = dialogContent.querySelector('.urban-gifting__select');
    const selectionFeedback = dialogContent.querySelector('.urban-gifting__selection-feedback');
    const removeButton = dialogContent.querySelector('.urban-gifting__remove');
    const sizeGuidePanel = dialogContent.querySelector('.urban-gifting__size-guide');
    dialogContent.querySelectorAll('[data-featured-look]').forEach((button) => button.addEventListener('click', () => {
      const look = featuredLooks.find((item) => String(item.id) === String(button.dataset.featuredLook));
      if (look) openLook(look);
    }));
    if (sizeGuidePanel) {
      setupSizeGuide(sizeGuidePanel, product.sizeGuide);
    }
    const findVariant = () => usable.find((variant) => options.every((option) => optionState[option.position] && variant[`option${option.position}`] === optionState[option.position]));
    const valueIsAvailable = (option, value) => usable.some((variant) => {
      if (variant[`option${option.position}`] !== value) return false;
      return options.every((other) => other.position === option.position || !optionState[other.position] || variant[`option${other.position}`] === optionState[other.position]);
    });
    const refreshTiming = () => {
      const variant = findVariant();
      const timing=dialogContent.querySelector('[data-product-shipping]');
      if(!timing)return;
      timing.textContent=variant ? shippingNote({...variant,productId:product.id}) : window.UrbanGiftingShipping?.summary(product,usable) || '';
      timing.hidden=!timing.textContent;
    };
    const refresh = () => {
      const variant = findVariant();
      selectButton.disabled = !variant;
      refreshTiming();
      if (!usable.length) {
        selectButton.textContent = 'UNAVAILABLE';
        return;
      }
      if (variant) selectorToggle.textContent = variant.title;
      else selectorToggle.textContent = `Select a ${choiceLabel}`;
      selectButton.textContent = variant ? (existing ? 'UPDATE SELECTION' : 'ADD TO GIFT BAG') : `SELECT A ${(options.find((option) => !optionState[option.position])?.name || primaryOption?.name || 'GIFT').toUpperCase()}`;
    };
    refreshProductTiming=()=>{if(dialog.open)refreshTiming();};
    const renderSelectors = () => {
      selectors.innerHTML = visibleOptions.map((option) => `<section class="urban-gifting__option" data-position="${option.position}">
        <p class="urban-gifting__option-name">${escapeHtml(option.name)}</p>
        <div class="urban-gifting__option-values">
          ${(viewOnly ? availableOptionValues(option) : option.values).map((value) => {
            const available = valueIsAvailable(option, value);
            const pressed = optionState[option.position] === value;
            if (viewOnly) return `<span class="urban-gifting__option-value">${escapeHtml(value)}</span>`;
            return `<button class="urban-gifting__option-value${available ? '' : ' is-unavailable'}" type="button" data-value="${escapeHtml(value)}" aria-pressed="${pressed}" ${available ? '' : 'disabled'}>${escapeHtml(value)}</button>`;
          }).join('')}
        </div>
      </section>`).join('');
      if (viewOnly) return;
      selectors.querySelectorAll('.urban-gifting__option-value:not(:disabled)').forEach((button) => button.addEventListener('click', () => {
        optionState[button.closest('[data-position]').dataset.position] = button.dataset.value;
        selectionFeedback.hidden = true;
        renderSelectors();
        refresh();
        if (findVariant()) {
          selectors.hidden = true;
          selectorToggle.setAttribute('aria-expanded', 'false');
        }
      }));
    };
    renderSelectors();
    refresh();
    if (viewOnly || !visibleOptions.length) selectorToggle.hidden = true;
    selectorToggle.addEventListener('click', () => {
      const expanded = selectorToggle.getAttribute('aria-expanded') === 'true';
      selectorToggle.setAttribute('aria-expanded', String(!expanded));
      selectors.hidden = expanded;
    });
    selectButton.addEventListener('click', () => {
      if (viewOnly || unconfirmedDelivery) return;
      const variant = findVariant();
      if (!variant) return;
      if (productOnly) selected.clear();
      selected.set(selectionKey(product, variant), {...variant, productId: product.id, productTitle: product.title, image: collectionProductImage(product, variant)});
      renderProducts();
      updateSelection();
      selectButton.textContent = 'ADDED TO GIFT BAG';
      selectionFeedback.textContent = '';
      selectionFeedback.hidden = true;
    });
    removeButton?.addEventListener('click', () => {
      if (existing) selected.delete(selectionKey(product, existing));
      if (!productOnly) dialog.close();
      renderProducts();
      updateSelection();
      if (productOnly) openProduct(product);
    });
    if (!dialog.open) dialog.showModal();
    resetProductDialogScroll();
  }

  function returnToProduct(from) {
    if (from === requestDialog && unconfirmedDelivery) return;
    if (requestYieldedToCaptcha) return;
    from.close();
    if (productOnly) openProduct(products.find(item=>numericId(item.id)===productScope.productId));
  }
  root.querySelector('.urban-gifting__close').addEventListener('click', () => {
    if (productOnly) return;
    if (activeLook && dialogContent.querySelector('.urban-gifting__dialog-page')) openLook(activeLook);
    else dialog.close();
  });
  root.querySelector('.urban-gifting__bag-close').addEventListener('click', () => returnToProduct(bagDialog));
  root.querySelector('.urban-gifting__request-close').addEventListener('click', () => returnToProduct(requestDialog));
  dialog.addEventListener('cancel',event=>{if(productOnly)event.preventDefault();});
  for (const child of [bagDialog,requestDialog]) child.addEventListener('cancel',event=>{if(unconfirmedDelivery){event.preventDefault();return;}if(productOnly){event.preventDefault();returnToProduct(child);}});
  dialog.addEventListener('click', (event) => { if (event.target === dialog && !productOnly) dialog.close(); });
  dialog.addEventListener('close', () => { activeLook = null; });
  bagDialog.addEventListener('click', (event) => { if (event.target === bagDialog) returnToProduct(bagDialog); });

  const gridMedia = window.matchMedia('(max-width: 749px)');
  let gridSets = gridMedia.matches ? [4, 2, 1] : [6, 3, 1];
  let gridIndex = 0;
  const gridButton = root.querySelector('.urban-gifting__grid-button');
  const setGridSize = () => {
    const fixedFeed = category === 'SHOP_LOOKS';
    gridButton.hidden = productOnly || pressMode || fixedFeed;
    if (fixedFeed) {
      productsNode.dataset.columns = '';
      productsNode.style.setProperty('display', 'block', 'important');
      productsNode.style.setProperty('width', '100%', 'important');
      productsNode.style.removeProperty('grid-template-columns');
      return;
    }
    const columns = gridSets[gridIndex];
    root.style.setProperty('--ug-columns', String(columns));
    productsNode.dataset.columns = String(columns);
    productsNode.style.setProperty('display', 'grid', 'important');
    productsNode.style.setProperty('width', '100%', 'important');
    productsNode.style.setProperty('grid-template-columns', `repeat(${columns}, minmax(0, 1fr))`, 'important');
    gridButton.setAttribute('aria-label', `Change product grid size. Currently ${columns} columns`);
  };
  setGridSize();
  gridButton.addEventListener('click', (event) => {
    event.preventDefault();
    gridIndex = (gridIndex + 1) % gridSets.length;
    setGridSize();
  });
  gridMedia.addEventListener('change', () => {
    gridSets = gridMedia.matches ? [4, 2, 1] : [6, 3, 1];
    gridIndex = 0;
    setGridSize();
  });

  let headerFrame = 0;
  const updateHeaderMode = () => {
    const header = root.querySelector('.urban-gifting__header');
    const reachedProducts = pressMode
      ? root.scrollTop > header.offsetHeight
      : productsNode.getBoundingClientRect().top <= root.getBoundingClientRect().top + header.offsetHeight;
    logoNode.hidden = reachedProducts;
    header.classList.toggle('is-over-products', reachedProducts);
  };
  const scheduleHeaderUpdate = () => {
    if (headerFrame) return;
    headerFrame = requestAnimationFrame(() => {
      updateHeaderMode();
      headerFrame = 0;
    });
  };
  root.addEventListener('scroll', scheduleHeaderUpdate, {passive: true});
  window.addEventListener('resize', scheduleHeaderUpdate, {passive: true});

  function shippingNote(item) {
    const product=products.find(p=>numericId(p.id)===numericId(item.productId));
    const variant=product?.variants?.find(v=>numericId(v.id)===numericId(item.id));
    const select=requestForm.elements.country;
    const country=select?.options[select.selectedIndex]?.dataset.countryCode || product?.countryCode || 'US';
    return window.UrbanGiftingShipping?.notice(product,variant,country) || '';
  }
  requestForm.elements.country?.addEventListener('change',()=>{renderRequestItems();renderBagItems();});
  function renderRequestItems() {
    requestItems.innerHTML = selected.size ? [...selected.entries()].map(([key, item]) => `<article class="urban-gifting__request-item">
      ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.productTitle || 'Gift')}">` : ''}
      <div>
        <span>${escapeHtml(item.productTitle || 'GIFT')}</span>
        <span>${escapeHtml(item.title || '')}</span>
        ${shippingNote(item) ? `<p class="urban-gifting__shipping-note">${escapeHtml(shippingNote(item))}</p>` : ''}
      </div>
      <button class="urban-gifting__request-remove" type="button" data-remove-selection="${escapeHtml(key)}" aria-label="Remove ${escapeHtml(item.productTitle || 'gift')} ${escapeHtml(item.title || '')}">×</button>
    </article>`).join('') : '<p class="urban-gifting__request-empty">YOUR GIFT BAG IS EMPTY. GO BACK TO SELECT A GIFT.</p>';
    requestItems.querySelectorAll('[data-remove-selection]').forEach((button) => button.addEventListener('click', () => {
      if (unconfirmedDelivery) return;
      selected.delete(String(button.dataset.removeSelection));
      renderProducts();
      updateSelection();
      renderRequestItems();
      if (productOnly && !selected.size) returnToProduct(requestDialog);
    }));
  }

  function renderBagItems() {
    bagItems.innerHTML = [...selected.entries()].map(([key, item]) => `<article class="urban-gifting__bag-item">
      <button class="urban-gifting__bag-product" type="button" data-open-product="${escapeHtml(item.productId)}" data-open-variant="${escapeHtml(item.id)}" aria-label="View ${escapeHtml(item.productTitle || 'gift')}">
        ${item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.productTitle || 'Gift')}">` : ''}
        <span><strong>${escapeHtml(item.productTitle || 'GIFT')}</strong><small>${escapeHtml(item.title || '')}</small>${shippingNote(item) ? `<small class="urban-gifting__shipping-note">${escapeHtml(shippingNote(item))}</small>` : ''}</span>
      </button>
      <button class="urban-gifting__bag-remove" type="button" data-remove-selection="${escapeHtml(key)}" aria-label="Remove ${escapeHtml(item.productTitle || 'gift')} ${escapeHtml(item.title || '')}">×</button>
    </article>`).join('');
    bagItems.querySelectorAll('[data-open-product]').forEach((button) => button.addEventListener('click', () => {
      const product = products.find((item) => String(item.id) === String(button.dataset.openProduct));
      if (!product) return;
      const variant = product.variants?.find((item) => String(item.id) === String(button.dataset.openVariant));
      const device = caseDeviceOption(product);
      if (productCategory(product) === 'CASE CLOSET' && device && variant) selectedCaseDevice = variant[`option${device.position}`];
      bagDialog.close();
      openProduct(product);
    }));
    bagItems.querySelectorAll('[data-remove-selection]').forEach((button) => button.addEventListener('click', () => {
      if (unconfirmedDelivery) return;
      selected.delete(String(button.dataset.removeSelection));
      renderProducts();
      updateSelection();
      renderBagItems();
      if (!selected.size) returnToProduct(bagDialog);
    }));
  }

  function openBag() {
    if (unconfirmedDelivery) { openRequest(); return; }
    if (!selected.size) return;
    if (dialog.open) dialog.close();
    renderBagItems();
    if (!bagDialog.open) bagDialog.showModal();
  }

  function openRequest() {
    if (!selected.size || (!isVIP && selected.size > maximum)) return;
    if (dialog.open) dialog.close();
    if (bagDialog.open) bagDialog.close();
    renderRequestItems();
    lockDelivery(unconfirmedDelivery);
    if (!requestDialog.open) requestDialog.showModal();
  }

  root.querySelectorAll('.urban-gifting__bag, .urban-gifting__bag-action').forEach((button) => button.addEventListener('click', openBag));
  stickySubmitButtons.forEach((button) => button.addEventListener('click', () => {
    if (!isVIP && selected.size > maximum) openBag();
    else openRequest();
  }));

  function setNativeField(id, value) {
    const input = nativeRequestForm?.querySelector(`[id="${id}"], [name="${id}"]`);
    if (!input) return;
    // Controlled inputs can track their own value setter. Use the DOM setter
    // so the input event is recognized as a value change by the native app.
    let prototype = Object.getPrototypeOf(input), setValue;
    while (prototype && !setValue) {
      setValue = Object.getOwnPropertyDescriptor(prototype, 'value')?.set;
      prototype = Object.getPrototypeOf(prototype);
    }
    if (setValue) setValue.call(input, value);
    else input.value = value;
    input.dispatchEvent(new Event('input', {bubbles: true, composed: true}));
    input.dispatchEvent(new Event('change', {bubbles: true, composed: true}));
  }

  function queryDeep(node, selector) {
    const direct = node?.querySelector?.(selector);
    if (direct) return direct;
    for (const element of node?.querySelectorAll?.('*') || []) {
      if (!element.shadowRoot) continue;
      const match = queryDeep(element.shadowRoot, selector);
      if (match) return match;
    }
    return null;
  }

  function bindNativeForm() {
    if (nativeFormBound) return;
    const section = document.querySelector('[id$="__urban_gifting_form"]');
    if (!section) {
      root.dataset.nativeFormStatus = 'waiting-for-section';
      window.setTimeout(bindNativeForm, 250);
      return;
    }
    // Forms must mount beneath the visible gifting root. Leaving the embed
    // under the hidden storefront while waiting for its form deadlocks loading.
    if (!nativeFormSlot.contains(section)) {
      section.classList.add('urban-gifting__native-form');
      nativeFormSlot.appendChild(section);
    }
    const form = queryDeep(section, 'form');
    if (!form) {
      root.dataset.nativeFormStatus = section ? 'waiting-for-form' : 'waiting-for-section';
      window.setTimeout(bindNativeForm, 250);
      return;
    }
    nativeFormBound = true;
    nativeRequestForm = form;
    root.dataset.nativeFormStatus = 'bound';
    if (!unconfirmedDelivery) requestError.hidden = true;
    const nativeRoot = nativeRequestForm.getRootNode();
    // A light-DOM form shares document with newsletter and other app forms.
    // Only this gifting section may acknowledge this request.
    const nativeStateRoot = nativeRoot === document ? section : nativeRoot;

    requestForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (nativeSubmissionPending) return;
      if (captureRestoreError || !capture || (unconfirmedDelivery && !activeCapture)) {
        requestError.textContent = captureRestoreError || 'Your previous submission cannot be checked automatically. Please ask our team to check it before sending another request.';
        requestError.hidden = false;
        return;
      }
      if (nativeSubmissionFailed || !nativeRequestForm?.isConnected) {
        nativeSubmissionFailed = true;
        await refreshNativeForm(true);
        return;
      }
      if (queryDeep(nativeStateRoot, '[data-current-step]')?.getAttribute('data-current-step') === 'success') {
        if (activeCapture) void confirmSavedCapture(true);
        return;
      }
      requestError.hidden = true;
      if (!selected.size) {
        requestError.textContent = 'Your gift bag is empty. Go back to select a gift.';
        requestError.hidden = false;
        return;
      }
      if (productOnly) {
        try {assertProductGiftSelection(campaign,tokenHash,[...selected.values()].map(item=>({...item,variantId:item.id})),products.flatMap(product=>(product.variants || []).map(variant=>({...variant,productId:product.id}))));}
        catch(error) {requestError.textContent=error.message;requestError.hidden=false;return;}
      }
      if (!requestForm.reportValidity()) return;
      const requiredNativeFields = ['email', 'custom#full_name', 'custom#instagram_or_tiktok', 'custom#campaign_token', 'custom#selected_gifts'];
      if (requiredNativeFields.some(id => !nativeRequestForm.querySelector(`[id="${id}"], [name="${id}"]`))) {
        requestError.textContent = 'The request form is not ready to receive your selection. Your gift bag is saved. Please refresh the page and try again.';
        requestError.hidden = false;
        return;
      }
      const formData = new Map(Object.entries(deliveryFields()));
      const instagram = String(formData.get('instagram') || '').trim();
      const tiktok = String(formData.get('tiktok') || '').trim();
      if (!instagram && !tiktok) {
        requestError.textContent = 'Please include an Instagram or TikTok handle.';
        requestError.hidden = false;
        requestForm.elements.instagram.focus();
        return;
      }
      const phone = String(formData.get('phone') || '').trim();
      const gifts = activeCapture ? JSON.parse(activeCapture.selectedJson).map(({captureNonce,capturePayloadHash,...gift})=>gift) : [...selected.values()].map((item) => ({
        variantId: item.id,
        productId: item.productId,
        productTitle: item.productTitle || 'Gift',
        variantTitle: item.title || '',
        shippingNote: shippingNote(item),
        image: item.image || '',
      }));
      const submit = requestForm.querySelector('.urban-gifting__submit');
      submit.disabled = true;
      submit.textContent = 'CHECKING SAVED REQUEST…';
      nativeSubmissionPending = true;
      lockDelivery(true);
      try {
        const previous = activeCapture;
        activeCapture = await capture.prepare(deliveryFields(),gifts);
        if (previous && await capture.check(activeCapture)) {showSubmissionSuccess();return;}
        capture.submitted(activeCapture);
      } catch (error) {
        nativeSubmissionPending = false;
        unconfirmedDelivery = Boolean(activeCapture);
        saveDeliveryDraft();
        lockDelivery(Boolean(activeCapture));
        nativeSubmissionFailed = Boolean(activeCapture);
        submit.disabled = false;
        submit.textContent = 'SUBMIT GIFT REQUEST';
        requestError.textContent = error.message || 'The saved request could not be checked. Your details are preserved.';
        requestError.hidden = false;
        return;
      }
      setNativeField('email', String(formData.get('email') || '').trim());
      setNativeField('custom#full_name', String(formData.get('full_name') || '').trim());
      setNativeField('custom#instagram_or_tiktok', [instagram && `Instagram: ${instagram}`, tiktok && `TikTok: ${tiktok}`].filter(Boolean).join(' | '));
      setNativeField('custom#address', String(formData.get('address') || ''));
      setNativeField('custom#apt_suite', String(formData.get('address_2') || ''));
      setNativeField('custom#city', String(formData.get('city') || ''));
      setNativeField('custom#state_province', String(formData.get('province') || ''));
      setNativeField('custom#postal_code', String(formData.get('postal_code') || ''));
      setNativeField('custom#country', String(formData.get('country') || ''));
      setNativeField('custom#phone', phone);
      setNativeField('custom#campaign_token', campaign.slug);
      setNativeField('custom#recipient_link_token', matchedInvite?.tokenHash || '');
      setNativeField('custom#selected_gifts', activeCapture.selectedJson);
      submit.disabled = true;
      submit.textContent = 'SUBMITTING…';
      nativeSubmissionPending = true;
      const attempt = ++nativeSubmissionAttempt;
      unconfirmedDelivery = true;
      saveDeliveryDraft();
      // Let the native app commit its input state before using its own button
      // handlers, including any verification setup attached to activation.
      window.setTimeout(() => {
        if (!nativeSubmissionPending || attempt !== nativeSubmissionAttempt) return;
        try {
          const nativeSubmit = nativeRequestForm.querySelector('button[type="submit"], input[type="submit"]');
          if (nativeSubmit) nativeSubmit.click();
          else nativeRequestForm.requestSubmit();
        } catch (_) {
          nativeSubmissionPending = false;
          unconfirmedDelivery = false;
          lockDelivery(false);
          saveDeliveryDraft();
          submit.disabled = false;
          submit.textContent = 'SUBMIT GIFT REQUEST';
          requestError.textContent = 'The request form could not start. Your gift bag is saved. Please try again.';
          requestError.hidden = false;
        }
      }, 0);
      window.setTimeout(() => {
        if (!document.contains(submit) || !nativeSubmissionPending || attempt !== nativeSubmissionAttempt) return;
        checkSubmissionState();
        if (!nativeSubmissionPending) return;
        if (!requestYieldedToCaptcha) void settleVerification();
      }, 12000);
    });

    function checkSubmissionState() {
      if (!nativeSubmissionPending) return;
      const nativeStep = queryDeep(nativeStateRoot, '[data-current-step]')?.getAttribute('data-current-step');
      if (nativeStep === 'success') {
        requestForm.querySelector('.urban-gifting__submit').textContent = 'CONFIRMING SAVED REQUEST…';
        void confirmSavedCapture(true);
      }
      // A button returning to idle does not establish failure: verification
      // or the request itself can still complete. Keep ambiguous attempts pending.
      else if (nativeStep === 'error') {
        nativeSubmissionPending = false;
        nativeSubmissionFailed = true;
        unconfirmedDelivery = true;
        saveDeliveryDraft();
        requestError.textContent = 'Request not received yet. Please try again.';
        requestError.hidden = false;
        const submit = requestForm.querySelector('.urban-gifting__submit');
        submit.disabled = false;
        submit.textContent = 'SUBMIT GIFT REQUEST';
        void confirmSavedCapture(true);
      }
    }
    // Forms can change the existing step's attribute without replacing a node.
    // Observe both so late success and error responses always restore the UI.
    new MutationObserver(checkSubmissionState).observe(nativeStateRoot, {childList: true, subtree: true, attributes:true, attributeFilter:['data-current-step','disabled','aria-disabled']});
    nativeRequestForm.addEventListener('invalid', (event) => {
      if (!nativeSubmissionPending) return;
      nativeSubmissionPending = false;
      unconfirmedDelivery = false;
      capture?.clear();
      activeCapture = null;
      lockDelivery(false);
      saveDeliveryDraft();
      requestError.textContent = event.target.validationMessage || 'Please review your delivery details and try again.';
      requestError.hidden = false;
      const submit = requestForm.querySelector('.urban-gifting__submit');
      submit.disabled = false;
      submit.textContent = 'SUBMIT GIFT REQUEST';
    }, true);
    updateSelection();
    void resumeNativeRetry();
  }

  bindNativeForm();
  if (activeCapture) {
    lockDelivery(true);
    void confirmSavedCapture(true);
  }
  document.addEventListener('visibilitychange',()=>{if(!document.hidden)shippingWatch?.refresh();});
  window.addEventListener('pageshow',()=>shippingWatch?.refresh());

  const collectionHandles = productOnly ? [] : Array.isArray(campaign.collectionHandles) ? campaign.collectionHandles : [campaign.collectionHandle || handle];
  Promise.all(collectionHandles.map((collectionHandle) => fetch(`${window.Shopify.routes.root}collections/${encodeURIComponent(collectionHandle)}?section_id=urban-gifting-data`, {headers: {Accept: 'text/html'}})
    .then((response) => { if (!response.ok) throw new Error(); return response.text(); })))
    .then(async (markups) => {
      const combined = markups.flatMap((markup) => {
        const documentNode = new DOMParser().parseFromString(markup, 'text/html');
        const payload = JSON.parse(documentNode.querySelector('[data-urban-gifting-products]')?.textContent || '{"products":[]}');
        return Array.isArray(payload.products) ? payload.products : [];
      });
      const [privateProducts, currentLookProducts] = await Promise.all([productOnly ? [] : privateCatalogProducts(), refreshedAssignedProducts()]);
      const mergedProducts = new Map([...combined, ...privateProducts].map((product) => [numericId(product.id), product]));
      currentLookProducts.forEach((freshProduct) => {
        const key = numericId(freshProduct.id);
        const existing = mergedProducts.get(key);
        if (!existing) {
          mergedProducts.set(key, freshProduct);
          return;
        }
        const existingVariants = new Map((existing.variants || []).map((variant) => [numericId(variant.id), variant]));
        mergedProducts.set(key, {
          ...existing,
          ...freshProduct,
          variants: (freshProduct.variants || []).map((variant) => {
            const existingVariant = existingVariants.get(numericId(variant.id));
            return {
              ...existingVariant,
              ...variant,
              usAvailable: existingVariant?.usAvailable === true || variant.usAvailable === true,
              jpAvailable: existingVariant?.jpAvailable === true || variant.jpAvailable === true,
            };
          }),
        });
      });
      if (productOnly && !currentLookProducts.some(item=>numericId(item.id)===productScope.productId)) throw new Error('Linked product unavailable');
      const savedProductOrder = campaign.productOrder?.length ? campaign.productOrder : (campaign.catalogProducts || []).map((item) => item.id || item.handle);
      const productOrder = new Map(savedProductOrder.map((item, index) => [numericId(item) || item, index]));
      products = [...mergedProducts.values()].filter(item=>!productOnly || numericId(item.id)===productScope.productId).sort((left, right) => {
        const leftRank = productOrder.get(numericId(left.id) || left.handle);
        const rightRank = productOrder.get(numericId(right.id) || right.handle);
        if (leftRank == null && rightRank == null) return 0;
        if (leftRank == null) return 1;
        if (rightRank == null) return -1;
        return leftRank - rightRank;
      });
      restoreSelection();
      selectionRestored = true;
      void resumeNativeRetry();
      const catalogProducts = campaignCatalogProducts();
      category = ['CLOTHING', 'CASE CLOSET', 'BAGS'].find((item) => catalogProducts.some((product) => productCategory(product) === item)) || 'CLOTHING';
      if (pressMode || campaignLooks().length > 0) category = 'LOOKS';
      renderCategories();
      renderProducts();
      updateSelection();
      updateHeaderMode();
      if (productOnly) openProduct(products[0]);
      shippingWatch?.stop();
      shippingWatch=window.UrbanGiftingShipping?.watchExpiry(products,()=>{renderBagItems();renderRequestItems();refreshProductTiming?.();});
    })
    .catch(() => { productsNode.innerHTML = '<p class="urban-gifting__empty">GIFTS COULD NOT BE LOADED. PLEASE REFRESH OR ASK OUR TEAM TO CHECK YOUR LINK.</p>'; });
})();



